export const buttonField = [
  {
    name: 'alt',
    label: 'Button alt',
    component: 'text',
  },
];

export const button = {
  name: 'media',
  label: 'Button Setting',
  component: 'group',
  fields: buttonField
};

export const buttonSimpleField = [
  {
    component: 'select',
    name: 'button.size',
    label: 'Size',
    options: [
      {label: 'large', value: 'large'},
      {label: 'middle', value: 'middle'},
      {label: 'small', value: 'small'}
    ],
  },
  {
    component: 'select',
    name: 'button.type',
    label: 'Type',
    options: [
      {label: 'default', value: 'default'},
      {label: 'primary', value: 'primary'},
      {label: 'danger', value: 'danger'},
      {label: 'ghost', value: 'ghost'},
      {label: 'dashed', value: 'dashed'},
      {label: 'link', value: 'link'},
      {label: 'text', value: 'text'},
    ],
  },
  {
    name: 'button.shape',
    component: 'toggle',
    label: 'Shape',
    ignoreResponsive: true,
    toggleLabels: {
      true: 'round',
      false: 'default',
    },
  },
  {
    name: 'button.redirect',
    label: 'Redirect',
    ignoreResponsive: true,
    component: 'text',
    placeholder: '/contact'
  },
];
